import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AlertService } from '../services/alert.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private alertService: AlertService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const currentUrl = this.router.url;
        const appType = (environment as any)?.appType || (
          currentUrl.includes('/mitra') ? 'mitra' :
          currentUrl.includes('/warehouse') ? 'warehouse' :
          currentUrl.includes('/transporter') ? 'transporter' : 'sales'
        );

        if (error.status === 401) {
          if (!currentUrl.includes('/login')) {
            const errData = error.error?.detail || error.error;
            const respCode = errData?.responseCode;
            const respMsg = errData?.responseMessage;

            if (respCode === '4012502') {
              this.alertService.warning(
                respMsg || 'Akun Anda telah login di perangkat lain atau sesi Anda telah diakhiri.',
                {
                  title: 'Sesi Login Berakhir',
                  confirmText: 'Login Kembali',
                  onClose: () => {
                    localStorage.removeItem('token');
                    this.router.navigate(['/login']);
                  }
                }
              );
            } else {
              localStorage.removeItem('token');
              this.router.navigate(['/login']);
            }
          }
        } else if (error.status === 403) {
          if (currentUrl !== '/' && currentUrl !== '' && !currentUrl.includes('/login') && !currentUrl.includes('/access')) {
            if (typeof localStorage !== 'undefined') {
              localStorage.setItem(`${appType}_is_inactive`, 'true');
            }
            if (appType === 'mitra') {
              this.router.navigate(['/access'], {
                queryParams: {
                  reason: 'forbidden',
                  from: currentUrl,
                  message: error?.error?.responseDesc || error?.error?.responseMessage || error?.error?.detail?.responseMessage || 'Akun Anda saat ini tidak aktif atau belum disetujui. Silakan hubungi admin / sales.'
                },
                replaceUrl: true
              });
            } else {
              this.router.navigate(['/'], { replaceUrl: true });
            }
          }
        }
        return throwError(() => error);
      })
    );
  }
}

